module.exports = __webpack_public_path__ + "static/media/deposit2.af80c474.png";